import { Component } from '@angular/core';
import { AppSettingService } from './services/app-setting.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'FlowSmart';

  constructor(settingService:AppSettingService) {}

}
